import ru from '@/utils/languages/Ru';
import en from '@/utils/languages/En';
import zh from '@/utils/languages/Zh';
import bg from '@/utils/languages/Bg';
import hi from '@/utils/languages/Hi';

export default {
  ru,
  en,
  zh,
  bg,
  hi,
};
